import { render, staticRenderFns } from "./CategoryAddSection.vue?vue&type=template&id=525bb502&scoped=true&"
import script from "./CategoryAddSection.vue?vue&type=script&lang=js&"
export * from "./CategoryAddSection.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAddSection.vue?vue&type=style&index=0&id=525bb502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525bb502",
  null
  
)

export default component.exports